import { useState } from 'react';
import MainLayout from '../../components/Layout/MainLayout';

/**
 * Home - Landing page for public users
 * Ported from static/js/views/homeView.js
 */
function Home() {
  const [modalImage, setModalImage] = useState({ src: '', alt: '' });
  const [showModal, setShowModal] = useState(false);

  const handleImageClick = (e, src, alt) => {
    e.preventDefault();
    setModalImage({ src, alt });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <MainLayout className="home home-main">
      <div id="content">
        <div className="home-main">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 col-sm-12 col-xs-12">&nbsp;</div>
              <div className="col-md-6 col-sm-12 col-xs-12">
                <div className="jumbo-tron">
                  <h2>Manage your projects</h2>
                  <p className="sub-heading">
                    When you choose to work with Seansoft Corporation on your software project, you also receive
                    this Agile management tool. With ScrumOnline, you can manage all of your projects, track the
                    time spent, and communicate with the people doing the work in real time from any device. Now
                    you have the tools to stay ahead of the game, and get the most out of your project dollars with
                    us.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row row1">
          <div className="col-md-12 center-block hp-cell">
            <h2>Quickly view project and task status, and communicate with your remote team!</h2>
            <p>
              Using this all in one toolkit, you can get instant status updates and messaging directly with your
              extended right shore team from wherever you are. Being able to check in and alter the course of work
              anywhere, anytime is a powerful ally in the 24 / 7 business world. It&apos;s agile project management and
              communication at its best.
            </p>
          </div>
          <div className="col-md-6 col-sm-12 col-xs-12 center-block hp-cell">
            <a
              href="#"
              className="show-image-link"
              onClick={(e) =>
                handleImageClick(e, '/images/project-details.png', 'View all tasks summary, progress and status.')
              }
            >
              <img className="image-content" src="/images/project-details.png" alt="View all tasks summary, progress and status." />
            </a>
          </div>
          <div className="col-md-6 col-sm-12 col-xs-12 center-block hp-cell">
            <a
              href="#"
              className="show-image-link"
              onClick={(e) =>
                handleImageClick(
                  e,
                  '/images/project-details-messaging.png',
                  'You can also use ScrumOnline to communicate with your developers. This is an all in one tool!'
                )
              }
            >
              <img
                className="image-content"
                src="/images/project-details-messaging.png"
                alt="You can also use ScrumOnline to communicate with your developers. This is an all in one tool!"
              />
            </a>
          </div>
        </div>

        <div className="row row2">
          <div className="col-md-6 col-sm-12 col-xs-12 center-block hp-cell">
            <div>
              <h2>Get realtime updates equals real control</h2>
              <p className="sub-heading">
                Tired of refreshing constantly and awaiting for updates? Messaging alerts are just one of the many
                features that help you streamline your workflow in project management!
              </p>
            </div>
          </div>
          <div className="col-md-6 col-sm-12 col-xs-12 center-block hp-cell">
            <a
              href="#"
              className="show-image-link"
              onClick={(e) =>
                handleImageClick(
                  e,
                  '/images/project-details-notifications.png',
                  "Don't get left behind! When you receive messages, you also receive notifications in real time! So you won't have to refresh your page every minute."
                )
              }
            >
              <img
                className="image-content"
                src="/images/project-details-notifications.png"
                alt="Don't get left behind! When you receive messages, you also receive notifications in real time! So you won't have to refresh your page every minute."
              />
            </a>
          </div>
        </div>

        <div className="row row3">
          <div className="col-md-6 col-sm-12 col-xs-12 center-block hp-cell">
            <a
              href="#"
              className="show-image-link"
              onClick={(e) =>
                handleImageClick(
                  e,
                  '/images/scrumboard.png',
                  'Scrumboard gives you a summary of what is going on with your tasks. The tasks works like a card that you can rearrange based on what you want to prioritize. Color coding acts like an alarm that tells you how much is left or gone over your estimated working hours for each task.'
                )
              }
            >
              <img
                className="image-content"
                src="/images/scrumboard.png"
                alt="Scrumboard gives you a summary of what is going on with your tasks. The tasks works like a card that you can rearrange based on what you want to prioritize. Color coding acts like an alarm that tells you how much is left or gone over your estimated working hours for each task."
              />
            </a>
          </div>
          <div className="col-md-6 col-sm-12 col-xs-12 center-block hp-cell">
            <div>
              <h2>Manage your tasks quickly and efficiently</h2>
              <p className="sub-heading">
                Developers get the complete picture simply by visualization of tasks on the scrumboard. Here you can
                easily identify which tasks are prioritized, what is in process and how much time has been spent and
                remain on estimated work.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      <div
        className={`modal fade ${showModal ? 'show' : ''}`}
        id="imagemodal"
        tabIndex="-1"
        role="dialog"
        aria-hidden={!showModal}
        style={{ display: showModal ? 'block' : 'none' }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close home-popover" onClick={handleCloseModal}>
                <span className="pull-right" aria-hidden="true">
                  &times;
                </span>
                <span className="sr-only">Close</span>
              </button>
            </div>
            <div className="modal-body">
              <img src={modalImage.src} id="imagepreview" alt={modalImage.alt} className="img-responsive" />
            </div>
            <div className="modal-footer">
              <div className="modal-caption">{modalImage.alt}</div>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show" onClick={handleCloseModal}></div>}
    </MainLayout>
  );
}

export default Home;
